/* import __COLOCATED_TEMPLATE__ from './template-content-switcher.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();